/**
 * @file components/biz/common/helper
 * @author zhangzhe
 */

import _ from 'lodash';

import request from '../../../utils/Request';

export function createPayload(payload: any, fields: any, extra?: any) {
    // fields: ['a', 'b', 'c'] -> u.pick(payload, fields);
    // fields: ['a', ['id', 'userId'], 'c'] ->
    const requestPayload = fields ? {} : _.extend({}, payload);
    _.each(fields, key => {
        if (_.isArray(key)) {
            const [a, b] = key;
            requestPayload[b] = payload[a];
        }
        else if (_.isString(key)) {
            requestPayload[key] = payload[key];
        }
    });
    return _.extend(requestPayload, extra);
}

export function createParams(payload: any, fields: any, extra: any) {
    const params: any[] = [];
    _.each(fields, key => {
        params.push(payload[key]);
    });
    _.each(extra, value => {
        params.push(value);
    });
    return params.join('/');
}

export function fetch(api: string, payload = {}, actions?: any) {
    if (actions) {
        return actions[api](payload);
    }
    return request.post(api, payload);
}
